// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResults-cls1_09H","cls2":"AutoCompleteResults-cls2_p97 AutoCompleteResults-cls1_09H"};